import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  DatePicker,
  Divider,
  Modal,
  Col,
  Card,
  Table,
  Form,
  Spin,
  Select,
  Button,
  Statistic,
  InputNumber,
} from "antd";
import { PlusCircleOutlined, LeftOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { CSVLink } from "react-csv";
import appStatic from "../../../../../config/appStatic";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { rightAction } from "../../../../../redux/actions";
import CustomButton from "../../../../../components/custom/CustomButton";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import styles from "../../../../../assets/styles/styles";
import dayjs from "dayjs";

const Search = Input;
const { Text } = Typography;

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const NewStandingInstructions = (props) => {
  const { userData } = props;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");

  const [name, setName] = useState("");
  const [priorityDetail, setPriorityDetail] = useState(null);
  const [statusDetail, setStatusDetail] = useState(null);
  const [transferTypeDetail, setTransferTypeDetail] = useState(null);
  const [fromAccountDetail, setFromAccountDetail] = useState(state?.id);
  const [destinationDetail, setDestinationDetail] = useState(null);
  const [toOfficeDetail, setToOfficeDetail] = useState(null);
  const [toClientDetail, setToClientDetail] = useState(null);
  const [toAccountTypeDetail, setToAccountTypeDetail] = useState(null);
  const [toAccountDetail, setToAccountDetail] = useState(null);

  const [standingInstructionsList, setStandingInstructionsList] = useState([]);
  const [transferTypeData, setTransferTypeData] = useState([]);
  const [toAccountData, setToAccountData] = useState([]);
  const [toAccountTypeData, setToAccountTypeData] = useState([]);
  const [priorityData, setPriorityData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [fromClientData, setFromClientData] = useState([]);
  const [fromOfficeData, setFromOfficeData] = useState([]);
  const [fromAccountTypeData, setFromAccountTypeData] = useState([]);
  const [fromAccountData, setFromAccountData] = useState([]);
  const [toOfficeData, setToOfficeData] = useState([]);
  const [toClientData, setToClientData] = useState([]);
  const [instructionTypeData, setInstructionTypeData] = useState([]);
  const [recurrenceTypeData, setRecurrenceTypeData] = useState([]);
  const [recurrenceFrequencyData, setRecurrenceFrequencyData] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  const selectedRecurrenceFrequency = Form.useWatch("recurrenceFrequency", useForm);
  const selectedRecurrenceType = Form.useWatch("recurrenceType", useForm);
  const recurrenceTypeLabel = recurrenceTypeData.find(
    (item) => item.value === selectedRecurrenceType
  )?.label;
  const recurrenceLabel = recurrenceFrequencyData.find(
    (item) => item.value === selectedRecurrenceFrequency
  )?.label;
  const mandateMonthDay =
    recurrenceLabel?.toLowerCase() === "months" || recurrenceLabel?.toLowerCase() === "years";
  const asPerDueSelected = recurrenceTypeLabel?.toLowerCase() === "as per dues recurrence";

  console.log(mandateMonthDay, asPerDueSelected);

  function selectTableCount(value) {
    setTableCount(value);
  }

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    console.log(state);

    // console.log(state);
    // console.log(customerDetails);
    getTemplate();
  }, []);

  const getTemplate = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${state.clientId}&fromOfficeId=${state.branchId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(objList);

        // const tempFromAccount = objList?.fromAccountOptions?.find(
        //   (item) => item?.accountNo === state?.accountNo
        // );

        // if (tempFromAccount) {
        //   tempFromAccount.label = `${tempFromAccount?.productName} - ${tempFromAccount?.accountNo}`;
        // }
        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
          fromAccountType: objList?.fromAccountType?.id,
          fromAccountId: state?.id,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            // label: element.productName,
            label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        // console.log(tempTransferTypeOptions);
        // console.log(tempFromAccountTypeOptions);
        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onChangeName = (e) => {
    setName(e.target.value);
  };

  const onChangeTranferType = (typeParam) => {
    setTransferTypeDetail(typeParam);
    getTransferTypeTemplate(typeParam);
  };

  const onChangePriorityDetail = (priorityParam) => {
    setPriorityDetail(priorityParam);
  };

  const onChangeStatusDetail = (statusParam) => {
    setStatusDetail(statusParam);
  };

  const onChangeFromAccount = (fromAccountParam) => {
    setFromAccountDetail(fromAccountParam);
    getFromAccountTemplate(fromAccountParam);
  };

  const onChangeDestination = (destinationParam) => {
    setDestinationDetail(destinationParam);
    if (destinationParam === 1) getDestinationTemplate(state?.clientId);
    else {
      return;
    }
  };

  const onChangeToOFfice = (toOfficeParam) => {
    setToOfficeDetail(toOfficeParam);
    getTOfficeIdTemplate(toOfficeParam);
    useForm.setFieldValue("toClientId", null);
    setToClientDetail(null);
  };

  const onChangeToClient = (toClientParam) => {
    setToClientDetail(toClientParam);
    getToClientTemplate(toClientParam);
  };

  const onChangeToAccountType = (toAccountTypeParam) => {
    setToAccountTypeDetail(toAccountTypeParam);
    getToAccountTypeTemplate(toAccountTypeParam);
  };

  const onChangeToAccount = (toAccountParam) => {
    setToAccountDetail(toAccountParam);
    getToAccountTemplate(toAccountParam);
  };

  const getTransferTypeTemplate = (typeParam) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""
    }${priorityDetail ? `&priority=${priorityDetail}` : ""}${
      statusDetail ? `&status=${statusDetail}` : ""
    }${toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""}${
      toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""
    }${toClientDetail ? `&toClientId=${toClientDetail}` : ""}${
      toOfficeDetail ? `&toOfficeId=${toOfficeDetail}` : ""
    }&transferType=${typeParam}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        // let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        // let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(tempTransferTypeOptions);

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        // objList.toAccountOptions.forEach((element) => {
        //   tempToAccountOptions.push({
        //     value: element.id,
        //     label: element.productName,
        //   });
        // });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        // objList.toClientOptions.forEach((element) => {
        //   tempToClientOptions.push({
        //     value: element.id,
        //     label: element.displayName,
        //   });
        // });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        console.log(tempTransferTypeOptions);
        console.log(tempFromAccountTypeOptions);
        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        // TODO
        // setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        // setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getFromAccountTemplate = (fromAccountParam) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${
      apiConfig.standingInstructions
    }/template?fromAccountId=${fromAccountParam}&fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      priorityDetail ? `&priority=${priorityDetail}` : ""
    }${statusDetail ? `&status=${statusDetail}` : ""}${
      toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    }${toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""}${
      toClientDetail ? `&toClientId=${toClientDetail}` : ""
    }${toOfficeDetail ? `&toOfficeId=${toOfficeDetail}` : ""}${
      transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    }`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        // let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        // let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element.productName,
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        // objList.toAccountOptions.forEach((element) => {
        //   tempToAccountOptions.push({
        //     value: element.id,
        //     label: element.productName,
        //   });
        // });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        // objList.toClientOptions.forEach((element) => {
        //   tempToClientOptions.push({
        //     value: element.id,
        //     label: element.displayName,
        //   });
        // });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        // setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        // setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getDestinationTemplate = (toClientId) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      priorityDetail ? `&priority=${priorityDetail}` : ""
    }${statusDetail ? `&status=${statusDetail}` : ""}${
      toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    }${toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""}${
      fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""
    }${
      transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    }&toClientId=${toClientId}&toOfficeId=${state.branchId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        // let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
          toOfficeId: objList?.toOffice?.id,
          toClientId: state?.clientId,
        });
        setToClientDetail(state?.clientId);

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element.productName,
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        // objList.toAccountOptions.forEach((element) => {
        //   tempToAccountOptions.push({
        //     value: element.id,
        //     label: element.productName,
        //   });
        // });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toClientOptions.forEach((element) => {
          tempToClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        // setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getTOfficeIdTemplate = (toOfficeParam) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      priorityDetail ? `&priority=${priorityDetail}` : ""
    }${statusDetail ? `&status=${statusDetail}` : ""}${
      toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    }${toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""}${
      fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""
    }${
      transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    }&toOfficeId=${toOfficeParam}`;
    // const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
    //   state.clientId
    // }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
    //   priorityDetail ? `&priority=${priorityDetail}` : ""
    // }${statusDetail ? `&status=${statusDetail}` : ""}${
    //   toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    // }${toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""}${
    //   toClientDetail ? `&toClientId=${toClientDetail}` : ""
    // }${fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""}${
    //   transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    // }&toOfficeId=${toOfficeParam}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        if (objList.toAccountOptions) {
          objList.toAccountOptions.forEach((element) => {
            if (element?.depositType === 300 || element?.depositType === 100) {
              tempToAccountOptions.push({
                value: element.id,
                label: element?.productName
                  ? `${element?.productName} - ${element?.accountNo}`
                  : "-",
              });
            }
          });
        }

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toClientOptions.forEach((element) => {
          tempToClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getToClientTemplate = (toClientParam) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      priorityDetail ? `&priority=${priorityDetail}` : ""
    }${statusDetail ? `&status=${statusDetail}` : ""}${
      toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    }${toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""}${
      toOfficeDetail ? `&toOfficeId=${toOfficeDetail}` : ""
    }${fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""}${
      transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    }&toClientId=${toClientParam}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
          fromAccountType: objList?.fromAccountType?.id,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        if (objList.toAccountOptions) {
          objList.toAccountOptions.forEach((element) => {
            if (element?.depositType === 300 || element?.depositType === 100) {
              tempToAccountOptions.push({
                value: element.id,
                label: element?.productName
                  ? `${element?.productName} - ${element?.accountNo}`
                  : "-",
              });
            }
          });
        }

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toClientOptions.forEach((element) => {
          tempToClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);
        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getToAccountTypeTemplate = (toAccountTypeParam) => {
    setIsLoading(true);

    let body = {
      session,
    };

    // const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
    //   state.clientId
    // }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
    //   priorityDetail ? `&priority=${priorityDetail}` : ""
    // }${statusDetail ? `&status=${statusDetail}` : ""}${
    //   toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    // }${fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""}${
    //   transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    // }&toAccountType=${toAccountTypeParam}&toClientId=${state.clientId}&toOfficeId=${
    //   state.branchId
    // }`;

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      priorityDetail ? `&priority=${priorityDetail}` : ""
    }${statusDetail ? `&status=${statusDetail}` : ""}${
      toAccountDetail ? `&toAccountId=${toAccountDetail}` : ""
    }${fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""}${
      transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    }&toAccountType=${toAccountTypeParam}&toClientId=${toClientDetail}&toOfficeId=${
      state.branchId
    }`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.toAccountOptions.forEach((element) => {
          if (element?.depositType === 300 || element?.depositType === 100) {
            tempToAccountOptions.push({
              value: element.id,
              label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
            });
          }
        });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toClientOptions.forEach((element) => {
          tempToClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getToAccountTemplate = (toAccountParam) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.standingInstructions}/template?fromAccountType=2&fromClientId=${
      state.clientId
    }&fromOfficeId=${state.branchId}${name ? `&name=${name}` : ""}${
      priorityDetail ? `&priority=${priorityDetail}` : ""
    }${statusDetail ? `&status=${statusDetail}` : ""}${
      toAccountTypeDetail ? `&toAccountType=${toAccountTypeDetail}` : ""
    }${fromAccountDetail ? `&fromAccountId=${fromAccountDetail}` : ""}${
      transferTypeDetail ? `&transferType=${transferTypeDetail}` : ""
    }&toAccountId=${toAccountParam}&toClientId=${state.clientId}&toOfficeId=${state.branchId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        // console.log(objList);
        // return;
        let tempTransferTypeOptions = [];
        let tempToAccountOptions = [];
        let tempToAccountTypeOptions = [];
        let tempPriorityOptions = [];
        let tempStatusOptions = [];
        let tempFromOfficeOptions = [];
        let tempFromClientOptions = [];
        let tempFromAccountTypeOptions = [];
        let tempFromAccountOptions = [];
        let tempToClientOptions = [];
        let tempToOfficeOptions = [];
        let tempInstructionTypeOptions = [];
        let tempRecurrenceTypeOptions = [];
        let tempRecurrenceFrequencyOptions = [];

        // console.log(objList);

        useForm.setFieldsValue({
          applicant: objList?.fromClient?.displayName,
        });

        objList.transferTypeOptions.forEach((element) => {
          tempTransferTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.priorityOptions.forEach((element) => {
          tempPriorityOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.statusOptions.forEach((element) => {
          tempStatusOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromOfficeOptions.forEach((element) => {
          tempFromOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.fromClientOptions.forEach((element) => {
          tempFromClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.fromAccountTypeOptions.forEach((element) => {
          tempFromAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.fromAccountOptions.forEach((element) => {
          tempFromAccountOptions.push({
            value: element.id,
            label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
          });
        });

        objList.toOfficeOptions.forEach((element) => {
          tempToOfficeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList.toAccountOptions.forEach((element) => {
          if (element?.depositType === 300 || element?.depositType === 100) {
            tempToAccountOptions.push({
              value: element.id,
              label: element?.productName ? `${element?.productName} - ${element?.accountNo}` : "-",
            });
          }
        });

        objList.toAccountTypeOptions.forEach((element) => {
          tempToAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.toClientOptions.forEach((element) => {
          tempToClientOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList.instructionTypeOptions.forEach((element) => {
          tempInstructionTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceTypeOptions.forEach((element) => {
          tempRecurrenceTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList.recurrenceFrequencyOptions.forEach((element) => {
          tempRecurrenceFrequencyOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setTransferTypeData(tempTransferTypeOptions);
        setToAccountTypeData(tempToAccountTypeOptions);
        setPriorityData(tempPriorityOptions);
        setStatusData(tempStatusOptions);
        setFromClientData(tempFromClientOptions);
        setFromOfficeData(tempFromOfficeOptions);
        setFromAccountTypeData(tempFromAccountTypeOptions);
        setFromAccountData(tempFromAccountOptions);
        setToAccountData(tempToAccountOptions);
        setToOfficeData(tempToOfficeOptions);
        setToClientData(tempToClientOptions);
        setInstructionTypeData(tempInstructionTypeOptions);
        setRecurrenceTypeData(tempRecurrenceTypeOptions);
        setRecurrenceFrequencyData(tempRecurrenceFrequencyOptions);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setChargesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return minDate != null && current.isBefore(minDate) && !current.isSame(minDate, "day");
    },
    [minDate]
  );

  const onSubmit = (formValues) => {
    formValues.validFrom = formValues.validFrom
      ? BOM.DateTime(formValues.validFrom, "only-date")
      : formValues.validFrom;

    formValues.validTill = formValues.validTill
      ? BOM.DateTime(formValues.validTill, "only-date")
      : formValues.validTill;

    formValues.recurrenceOnMonthDay = formValues.recurrenceOnMonthDay
      ? BOM.DateTimeWithoutYear(formValues.recurrenceOnMonthDay, "only-date")
      : formValues.recurrenceOnMonthDay;

    formValues.fromOfficeId = state.branchId;
    formValues.fromClientId = state.clientId;

    delete formValues.applicant;
    delete formValues.destination;
    // console.log(formValues);
    // return;
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      monthDayFormat: "dd MMMM",
      locale: "en",
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, `${apiConfig.standingInstructions}`, (err, res) => {
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newStandingInstructionMsg);
        navigate("/detail-savings-account", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-savings-account", { state: state });
  }

  console.log(recurrenceTypeData);
  return (
    <>
      <MainLayout isEnableRightSidebar={false}>
        <TopContent
          pageTitle={labelConfig.newStandingInstruction}
          pageItems={staticConfig.newStandingInstructionsBreadcrumbItems}
        />
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Card
            headStyle={{ borderBottomWidth: 0 }}
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={
              <Row
                style={{
                  alignContent: "center",
                  width: "8%",
                }}
              >
                <Button
                  icon={<LeftOutlined />}
                  type="text"
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                  }}
                  onClick={onCancel}
                >
                  <Text
                    style={{
                      marginTop: "auto",
                      marginBottom: "auto",
                      fontSize: 15,
                    }}
                  >
                    Back
                  </Text>
                </Button>
              </Row>
            }
          >
            <Form
              initialValues={{
                active: false,
                isStaff: false,
                openCasa: false,
              }}
              form={useForm}
              layout="vertical"
              onFinish={onSubmit}
              name="customer-info"
            >
              {/* <Text>RENDER TABLE LIST HERE</Text> */}
              <Row style={{ justifyContent: "space-betwen" }}>
                <Divider orientation="left" orientationMargin="0">
                  {/* <Text level={3} style={{ margin: 0, marginBottom: 0 }}> */}
                  {labelConfig.generalInfo}
                  {/* </Text> */}
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="name"
                    label={<Text strong>{labelConfig.name}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.name),
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                      onChange={onChangeName}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="applicant"
                    label={<Text strong>{labelConfig.applicant}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.applicant),
                      },
                    ]}
                  >
                    <Input disabled placeholder={BOM.handlePlaceholderMsg(labelConfig.applicant)} />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="transferType"
                    label={<Text strong>{labelConfig.type}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.type),
                      },
                    ]}
                  >
                    <Select
                      options={transferTypeData}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.type, "select")}
                      onChange={onChangeTranferType}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="priority"
                    label={<Text strong>{labelConfig.priority}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.priority),
                      },
                    ]}
                  >
                    <Select
                      onChange={onChangePriorityDetail}
                      options={priorityData}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.priority, "select")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="status"
                    label={<Text strong>{labelConfig.status}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.status),
                      },
                    ]}
                  >
                    <Select
                      onChange={onChangeStatusDetail}
                      options={statusData}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.status, "select")}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="fromAccountType"
                    label={<Text strong>{labelConfig.fromAccountType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.fromAccountType),
                      },
                    ]}
                  >
                    <Select
                      options={fromAccountTypeData}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.fromAccountType, "select")}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="fromAccountId"
                    label={<Text strong>{labelConfig.fromAccount}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.fromAccount),
                      },
                    ]}
                  >
                    <Select
                      disabled
                      options={fromAccountData}
                      onChange={onChangeFromAccount}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.fromAccount, "select")}
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0">
                  {labelConfig.beneficiaryInfo}
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="destination"
                    label={<Text strong>{labelConfig.destination}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.destination),
                      },
                    ]}
                  >
                    <Select
                      options={staticConfig.destinationData}
                      onChange={onChangeDestination}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.destination, "select")}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="toOfficeId"
                    label={<Text strong>{labelConfig.toBranch}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.toBranch),
                      },
                    ]}
                  >
                    <Select
                      options={toOfficeData}
                      onChange={onChangeToOFfice}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.toBranch, "select")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="toClientId"
                    label={<Text strong>{labelConfig.beneficiary}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.beneficiary),
                      },
                    ]}
                  >
                    <Select
                      options={toClientData}
                      onChange={onChangeToClient}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.beneficiary, "select")}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="toAccountType"
                    label={<Text strong>{labelConfig.toAccountType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.toAccountType),
                      },
                    ]}
                  >
                    <Select
                      options={toAccountTypeData}
                      onChange={onChangeToAccountType}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.toAccountType, "select")}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="toAccountId"
                    label={<Text strong>{labelConfig.toAccount}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.toAccount),
                      },
                    ]}
                  >
                    <Select
                      options={toAccountData}
                      onChange={onChangeToAccount}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.toAccount, "select")}
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0">
                  {labelConfig.instructionInfo}
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="instructionType"
                    label={<Text strong>{labelConfig.standingInstructionType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.standingInstructionType),
                      },
                    ]}
                  >
                    <Select
                      options={instructionTypeData}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.standingInstructionType,
                        "select"
                      )}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="amount"
                    label={<Text strong>{labelConfig.amount}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.amount),
                      },
                    ]}
                  >
                    <InputNumber
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                      style={styles.ofInputFieldNumber}
                      formatter={BOM.FormatAmount}
                      parser={BOM.ParseAmount}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="validFrom"
                    label={<Text strong>{labelConfig.validityFrom}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.validityFrom),
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      disabledDate={disableDaysBeforeToday}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.validityFrom, "select")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="validTill"
                    label={<Text strong>{labelConfig.to}</Text>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(labelConfig.to),
                    //   },
                    // ]}
                  >
                    <DatePicker
                      disabledDate={disableDaysBeforeToday}
                      style={{ width: "100%" }}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.to, "select")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="recurrenceType"
                    label={<Text strong>{labelConfig.recurrenceType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.recurrenceType),
                      },
                    ]}
                  >
                    <Select
                      options={recurrenceTypeData}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.recurrenceType, "select")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="recurrenceInterval"
                    label={<Text strong>{labelConfig.interval}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.interval),
                      },
                    ]}
                  >
                    <InputNumber
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.interval)}
                      style={styles.ofInputFieldNumber}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="recurrenceFrequency"
                    label={<Text strong>{labelConfig.recurrenceFrequency}</Text>}
                    rules={[
                      {
                        required: !asPerDueSelected,
                        message: BOM.CheckReqFld(labelConfig.recurrenceFrequency),
                      },
                    ]}
                  >
                    <Select
                      options={recurrenceFrequencyData}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.recurrenceFrequency,
                        "select"
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="recurrenceOnMonthDay"
                    label={<Text strong>{labelConfig.onMonthDay}</Text>}
                    rules={[
                      {
                        required: mandateMonthDay && !asPerDueSelected,
                        message: BOM.CheckReqFld(labelConfig.onMonthDay),
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.onMonthDay, "select")}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Divider />
                {/* {BOM.HasPermission("CREATE_CLIENT") && ( */}
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                  isLoading={isLoading}
                />
                {/* )} */}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form>
          </Card>
        </Spin>
      </MainLayout>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(NewStandingInstructions);
